import {
  CloseCircleOutlined,
  DownloadOutlined as AntDownloadOutlined,
  FileImageOutlined,
  FilePdfOutlined,
  FileTextOutlined as AntFileTextOutlined,
  VideoCameraOutlined,
  SoundOutlined,
  CodeOutlined,
  FileOutlined,
  FileZipOutlined,
  PaperClipOutlined,
  MessageOutlined as AntMessageOutlined,
  LeftOutlined as AntLeftOutlined,
  RightOutlined as AntRightOutlined,
  CloseOutlined,
  DeleteOutlined as AntDeleteOutlined,
  QuestionCircleOutlined as AntQuestionCircleOutlined,
  LogoutOutlined as AntLogoutOutlined,
  UserOutlined as AntUserOutlined,
  SmileOutlined,
  SendOutlined as AntSendOutlined,
  PlusCircleOutlined,
  CloudUploadOutlined,
  BellOutlined as AntBellOutlined,
  EyeInvisibleOutlined as AntEyeInvisibleOutlined,
  EyeOutlined as AntEyeOutlined,
  ShoppingCartOutlined as AntShoppingCartOutlined,
  AppstoreOutlined as AntAppstoreOutlined,
  LikeOutlined as AntLikeOutlined,
  NotificationOutlined as AntNotificationOutlined,
  SafetyCertificateOutlined as AntSafetyCertificateOutlined,
  TeamOutlined as AntTeamOutlined,
  SearchOutlined as AntSearchOutlined,
  SettingOutlined as AntSettingOutlined,
  FilterOutlined as AntFilterOutlined,
  SwapOutlined as AntSwapOutlined,
  UploadOutlined as AntUploadOutlined,
  LockOutlined as AntLockOutlined,
  LockFilled as AntLockFilled,
  UpOutlined as AntUpOutlined,
  DownOutlined as AntDownOutlined,
  ExclamationCircleFilled as AntExclamationCircleFilled,
  CheckOutlined as AntCheckOutlined,
  CarOutlined as AntCarOutlined,
  InfoCircleFilled as AntInfoCircleFilled,
  StarOutlined as AntStarOutlined,
  StarFilled as AntStarFilled,
  ShoppingFilled as AntShoppingFilled,
  FileDoneOutlined as AntFileDoneOutlined,
  MenuOutlined as AntMenuOutlined,
  CaretUpFilled as AntCaretUpFilled,
  CaretDownFilled as AntCaretDownFilled,
  UnorderedListOutlined as AntUnorderedListOutlined,
  MinusCircleOutlined as AntMinusCircleOutlined,
} from "@ant-design/icons";
import React from "react";

type IconProps = Record<string, any>;

const withCompatProps = (IconComponent: React.ComponentType<any>) => {
  const Component = ({ sx, fontSize, style, ...props }: IconProps) => (
    <IconComponent
      style={{
        ...(fontSize ? { fontSize } : {}),
        ...(sx ?? {}),
        ...(style ?? {}),
      }}
      {...props}
    />
  );
  Component.displayName = `MuiCompatIcon(${IconComponent.displayName ?? "Icon"})`;
  return Component;
};

export const Cancel = withCompatProps(CloseCircleOutlined);
export const Download = withCompatProps(AntDownloadOutlined);
export const Image = withCompatProps(FileImageOutlined);
export const PictureAsPdf = withCompatProps(FilePdfOutlined);
export const Description = withCompatProps(AntFileTextOutlined);
export const VideoLibrary = withCompatProps(VideoCameraOutlined);
export const Audiotrack = withCompatProps(SoundOutlined);
export const Code = withCompatProps(CodeOutlined);
export const InsertDriveFile = withCompatProps(FileOutlined);
export const Archive = withCompatProps(FileZipOutlined);
export const AttachFile = withCompatProps(PaperClipOutlined);
export const ChatBubble = withCompatProps(AntMessageOutlined);
export const ChevronLeft = withCompatProps(AntLeftOutlined);
export const Close = withCompatProps(CloseOutlined);
export const Delete = withCompatProps(AntDeleteOutlined);
export const HelpOutline = withCompatProps(AntQuestionCircleOutlined);
export const Logout = withCompatProps(AntLogoutOutlined);
export const Person = withCompatProps(AntUserOutlined);
export const EmojiEmotions = withCompatProps(SmileOutlined);
export const Send = withCompatProps(AntSendOutlined);
export const AddCircleOutline = withCompatProps(PlusCircleOutlined);
export const CloudUpload = withCompatProps(CloudUploadOutlined);
export const LeftOutlined = withCompatProps(AntLeftOutlined);
export const RightOutlined = withCompatProps(AntRightOutlined);
export const DeleteOutlined = withCompatProps(AntDeleteOutlined);
export const MessageOutlined = withCompatProps(AntMessageOutlined);
export const UserOutlined = withCompatProps(AntUserOutlined);
export const BellOutlined = withCompatProps(AntBellOutlined);
export const EyeOutlined = withCompatProps(AntEyeOutlined);
export const EyeInvisibleOutlined = withCompatProps(AntEyeInvisibleOutlined);
export const ShoppingCartOutlined = withCompatProps(AntShoppingCartOutlined);
export const QuestionCircleOutlined = withCompatProps(AntQuestionCircleOutlined);
export const DownloadOutlined = withCompatProps(AntDownloadOutlined);
export const AppstoreOutlined = withCompatProps(AntAppstoreOutlined);
export const FileTextOutlined = withCompatProps(AntFileTextOutlined);
export const LikeOutlined = withCompatProps(AntLikeOutlined);
export const NotificationOutlined = withCompatProps(AntNotificationOutlined);
export const SafetyCertificateOutlined = withCompatProps(
  AntSafetyCertificateOutlined
);
export const TeamOutlined = withCompatProps(AntTeamOutlined);
export const SearchOutlined = withCompatProps(AntSearchOutlined);
export const SettingOutlined = withCompatProps(AntSettingOutlined);
export const FilterOutlined = withCompatProps(AntFilterOutlined);
export const SwapOutlined = withCompatProps(AntSwapOutlined);
export const UploadOutlined = withCompatProps(AntUploadOutlined);
export const LockOutlined = withCompatProps(AntLockOutlined);
export const LockFilled = withCompatProps(AntLockFilled);
export const UpOutlined = withCompatProps(AntUpOutlined);
export const DownOutlined = withCompatProps(AntDownOutlined);
export const ExclamationCircleFilled = withCompatProps(
  AntExclamationCircleFilled
);
export const CheckOutlined = withCompatProps(AntCheckOutlined);
export const CarOutlined = withCompatProps(AntCarOutlined);
export const InfoCircleFilled = withCompatProps(AntInfoCircleFilled);
export const StarOutlined = withCompatProps(AntStarOutlined);
export const StarFilled = withCompatProps(AntStarFilled);
export const ShoppingFilled = withCompatProps(AntShoppingFilled);
export const FileDoneOutlined = withCompatProps(AntFileDoneOutlined);
export const MenuOutlined = withCompatProps(AntMenuOutlined);
export const CaretUpFilled = withCompatProps(AntCaretUpFilled);
export const CaretDownFilled = withCompatProps(AntCaretDownFilled);
export const UnorderedListOutlined = withCompatProps(AntUnorderedListOutlined);
export const MinusCircleOutlined = withCompatProps(AntMinusCircleOutlined);

const icons = {
  Cancel,
  Download,
  Image,
  PictureAsPdf,
  Description,
  VideoLibrary,
  Audiotrack,
  Code,
  InsertDriveFile,
  Archive,
  AttachFile,
  ChatBubble,
  ChevronLeft,
  Close,
  Delete,
  HelpOutline,
  Logout,
  Person,
  EmojiEmotions,
  Send,
  AddCircleOutline,
  CloudUpload,
  LeftOutlined,
  RightOutlined,
  DeleteOutlined,
  MessageOutlined,
  UserOutlined,
  BellOutlined,
  EyeOutlined,
  EyeInvisibleOutlined,
  ShoppingCartOutlined,
  QuestionCircleOutlined,
  DownloadOutlined,
  AppstoreOutlined,
  FileTextOutlined,
  LikeOutlined,
  NotificationOutlined,
  SafetyCertificateOutlined,
  TeamOutlined,
  SearchOutlined,
  SettingOutlined,
  FilterOutlined,
  SwapOutlined,
  UploadOutlined,
  LockOutlined,
  LockFilled,
  UpOutlined,
  DownOutlined,
  ExclamationCircleFilled,
  CheckOutlined,
  CarOutlined,
  InfoCircleFilled,
  StarOutlined,
  StarFilled,
  ShoppingFilled,
  FileDoneOutlined,
  MenuOutlined,
  CaretUpFilled,
  CaretDownFilled,
  UnorderedListOutlined,
  MinusCircleOutlined,
};

export default icons;
